import {Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {Observable} from 'rxjs';
import {Country} from 'src/app/modules/shared/models/country.model';
import {CountriesService} from 'src/app/modules/shared/services/countries.service';
import {AppLoadingEventsEmitter} from 'src/app/modules/shared/events/loading.events';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {AuthService} from 'src/app/modules/shared/services/auth.service';
import {NotificationsService} from 'src/app/modules/shared/services/notification.service';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {HttpErrorResponse} from '@angular/common/http';
import {TermsAndConditionsModalComponent} from '../../../shared/components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {getCookie} from '../../../shared/utilities/cookie.utilities';
import {Languages} from '../../../shared/enums/languages';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterComponent implements OnInit, AfterViewInit {
    @ViewChild('email') email: ElementRef<HTMLElement>;
    @ViewChild('step1Group') step1Group: ElementRef<HTMLElement>;
    @ViewChild('step2Group') step2Group: ElementRef<HTMLElement>;
    @ViewChild('nextStepButton') nextStepButton: ElementRef<HTMLElement>;
    @ViewChild('registerButton') registerButton: ElementRef<HTMLElement>;

    languages = Object.keys(Languages).map(k => Languages[k]);

    registerForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(5)]),
    });
    userHasAgreedToTermsAndConditions = false;
    over18 = false;
    countries: Observable<Country[]>;
    currentlySelectedCountry: Country;
    bsModalRef: BsModalRef;
    selected: string;
    onStep1 = true;

    constructor(
        private readonly countriesService: CountriesService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly router: Router,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
        private readonly usersService: UsersService,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter
    ) {
    }

    ngOnInit() {
        this.countries = this.countriesService.getCountries();
        this.selected = 'BG';
    }

    ngAfterViewInit() {
        this.email.nativeElement.dispatchEvent(new Event('click'));
    }

    onCountrySelected(country: Country) {
        this.currentlySelectedCountry = country;
        this.changeDetectorRef.markForCheck();
    }

    onSignUp() {
        const email: string = this.registerForm.controls['email'].value;
        const password: string = this.registerForm.controls['password'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.authService
            .register({
                email,
                password,
                locale: this.localisationService.getLanguage(),
                country: 'BG',
                referral: getCookie('referral')
            })
            .subscribe(
                async () => {
                    this.usersService.getUserProfile().subscribe(async () => {
                        await this.router.navigate(['dashboard']);

                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    });
                },
                (err: HttpErrorResponse) => {
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                    if (err.status === 400) {
                        this.notificationService.error(this.localisationService.localise('auth_err_email_already_exists'));
                    } else {
                        this.notificationService.error(this.localisationService.localise('server_err_something_went_wrong'));
                    }
                }
            );
    }

    openTermsAndConditions(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.bsModalRef = this.bsModalService.show(TermsAndConditionsModalComponent, {
            backdrop: true
        });

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    emailChanged(e: Event) {
        // const target = e.target as HTMLInputElement;
        //
        // if (target.value.length > 0 && this.registerForm.controls['email'].valid) {
        //     this.nextStepButton.nativeElement.classList.add('animated');
        //     this.nextStepButton.nativeElement.classList.add('fadeInUp');
        //     this.nextStepButton.nativeElement.classList.remove('hidden');
        // }
    }

    passwordChanged(e: Event) {
        if (this.onStep1) {
            return;
        }

        // const target = e.target as HTMLInputElement;
        //
        // if (target.value.length > 0 && this.registerForm.controls['password'].valid) {
        //     this.registerButton.nativeElement.classList.add('animated');
        //     this.registerButton.nativeElement.classList.add('fadeInUp');
        //     this.registerButton.nativeElement.classList.remove('hidden');
        // }
    }

    nextStep() {
        // if (this.registerForm.controls['email'].valid) {
        //     this.nextStepButton.nativeElement.classList.add('animated');
        //     this.nextStepButton.nativeElement.classList.add('fadeOut');
        //
        //     this.step1Group.nativeElement.classList.add('animated');
        //     this.step1Group.nativeElement.classList.add('fadeOutUp');
        //
        //     this.onStep1 = false;
        //
        //     const _this = this;
        //     setTimeout(function () {
        //         _this.step1Group.nativeElement.classList.add('hidden');
        //
        //         _this.step2Group.nativeElement.classList.add('animated');
        //         _this.step2Group.nativeElement.classList.add('fadeInUp');
        //         _this.step2Group.nativeElement.classList.remove('hidden');
        //     }, 1000);
        // }
    }

    onLanguageSelected(locale: Languages) {
        let url = this.router.url;
        url = url.substr(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length));

        window.location.href = url + '?lang=' + locale.toLocaleLowerCase();
    }

    flagIcon(language: Languages): string {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    }
}
